import { createSlice } from "@reduxjs/toolkit";
import i18n from "../../i18n";
import { getToken } from "../../utils/tokenStore";

const updateUserLanguage = async (language: string) => {
  try {
    const userId = sessionStorage.getItem("userId");
    const query = userId ? `?user_id=${userId}` : "";
    const url = `${process.env.REACT_APP_BASE_API_URL}/language${query}`;

    const token = getToken();
    await fetch(url, {
      method: "PUT",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ language: language }),
    });
  } catch (error) {
    console.error("Failed to update user language:", error);
  }
};

const languageSlice = createSlice({
  name: "language",
  initialState: { lang: "en" },
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
      i18n.changeLanguage(action.payload);
      updateUserLanguage(action.payload);
    },
    setInitialLanguage: (state, action) => {
      state.lang = action.payload;
      i18n.changeLanguage(action.payload);
    },
  },
});

export const { setLanguage, setInitialLanguage } = languageSlice.actions;
export default languageSlice.reducer;
